export default __webpack_public_path__ + "static/media/1429.2333d366.png";